import ApiService from "@/utils/request";

export const subscribeServe = {
  update(params) {
    return ApiService.post(
      `/policy/v2/inner/subscribe/increase_update/`,
      params
    );
  },
  add(params) {
    return ApiService.post(`/policy/v2/inner/subscribe/increase/`, params);
  },
  getTag() {
    return ApiService.get("/policy/v2/inner/tag_search/");
  },
  getSubscribe() {
    return ApiService.get("/policy/v2/inner/subscribe/user_tag/");
  },
};
